"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetTypes = void 0;
var AssetTypes;
(function (AssetTypes) {
    AssetTypes["native"] = "native";
    AssetTypes["credit_alphanum4"] = "credit_alphanum4";
    AssetTypes["credit_alphanum12"] = "credit_alphanum12";
    AssetTypes["SAC"] = "SAC";
    AssetTypes["token"] = "token";
    AssetTypes["liquidity_pool_shares"] = "liquidity_pool_shares";
})(AssetTypes || (exports.AssetTypes = AssetTypes = {}));
